import React, { useEffect, useState } from "react";
import axios from "axios";
import Select from "react-select";
import { useNavigate, useParams } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css"; // Import the CSS

const Blogedit = () => {
  const navigate = useNavigate();
  const token = localStorage.getItem("token");
  const { id } = useParams(); // Get the 'id' from URL params
  const [isClient, setIsClient] = useState(false);
const [categories, setCategories] = useState([]); // All available categories
const [selectedCategories, setSelectedCategories] = useState([]); // Selected ones

 
  useEffect(() => {
  const fetchCategories = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/category/fetch`);
      if (response.data.success) {
        const categoryOptions = response.data.categories.map((cat) => ({
          value: cat._id,
          label: cat.name,
        })).sort((a, b) => a.label.localeCompare(b.label));
        setCategories(categoryOptions);
      } else {
        toast.error("Failed to fetch categories");
      }
    } catch (error) {
      toast.error("Error fetching categories");
      console.error(error);
    }
  };

  fetchCategories();
}, []);


  useEffect(() => {
    setIsClient(true);
  }, []);

  const [blogById, setBlogById] = useState({
    title: "",
    url: "",
    introduction: "",
    content: "",
    metaDiscription: "",
    metaTitle: "",
    metaKeywords: "",
    blogId: "",
    categories:""
  });
  const [error, setError] = useState(null);
  const [file, setFile] = useState(null);
  const [fileUrl, setFileUrl] = useState("");
  // Text state for CKEditor and textarea

  // Form state
  const [data, setData] = useState({
    title: "",
    url: "",
    introduction: "",
    content: "",
    metaDiscription: "",
    metaTitle: "",
    metaKeywords: "",
    blogId: "",
    categories:"",
     featuredImage: null,
  });

  // Fetch blog by ID
  const fetchBlogsById = async (id) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/user/list/${id}`,
        { headers: { token } }
      );
      if (response.data.success) {
        const blog = response.data.blogs;
        setBlogById(blog);
        // Convert blog's categories to Select-compatible format
        const formattedCategories = blog.categories.map((cat) => ({
          value: cat._id,
          label: cat.name,
        }));
        setSelectedCategories(formattedCategories);
      } else {
        toast.error("Unauthorized access");
      }
    } catch (error) {
      setError("Failed to fetch data");
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    if (id) {
      fetchBlogsById(id);
    }
  }, [id]);
 const categoryIds = selectedCategories.map((cat) => cat.value);
  // Update `data` and `text` once `blogById` is fetched
  useEffect(() => {
    if (blogById) {
      setData((prevData) => ({
        ...prevData,
        title: blogById.title || "",
        url: blogById.url || "",
        introduction: blogById.introduction || "",
        content: blogById.content || "",
        metaDiscription: blogById.metaDiscription || "",
        metaTitle: blogById.metaTitle || "",
        metaKeywords: blogById.metaKeywords || "",
        blogId: blogById._id || "",
        categories:categoryIds || "",
         featuredImage: blogById.featuredImage || null,
      }));
    }
  }, [blogById]);

  // Input change handler
  const onChangeHandler = (event) => {
    const { name, value } = event.target;
    setData((prevData) => ({
      ...prevData,
      [name]: value,
      ...(name === "title" && { url: createSlug(value) }), // Auto-generate slug
    }));
  };

  const handleFileUpload = async (e) => {
    e.preventDefault();

    if (!file) {
      toast.error("Please select a file first.");
      return;
    }

    const formData = new FormData();
    formData.append("upload", file); // "upload" should match the backend field name

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/user/uploadFile`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (response.data.uploaded) {
        setFileUrl(response.data.url);
        toast.success("File uploaded successfully!");
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      console.error("Upload failed:", error);
      toast.error("Error uploading file.");
    }
  };

  const handleCopy = () => {
    navigator.clipboard.writeText(fileUrl);
    toast.success("Copied to clipboard!");
  };

  // Form submit handler
  const onSubmitHandler = async (event) => {
    event.preventDefault();
    
    if (createSlug(data.url) !== data.url) {
      toast.error("URL must contain only hyphens and lowercase letters.");
      return;
    }
 // 🟡 Add this line to ensure categories are updated
  const updatedData = {
    ...data,
    categories: selectedCategories.map((cat) => cat.value),
  };
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/user/addArticle`,
        updatedData,
        { headers: { token } }
      );

      if (response.data.success) {
        toast.success(response.data.message);

        // Reset form
        setData({
          title: "",
          url: "",
          introduction: "",
          content: "",
          metaDiscription: "",
          metaTitle: "",
          metaKeywords: "",
          blogId: "",
          featuredImage:null
        });
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      toast.error("An error occurred while submitting the article.");
      console.error(error);
    }
  };

  const initializeCKEditor = (data, setData) => {
    console.log(data, "----------------------data");
    if (data.introduction === "" || !window.CKEDITOR) {
      console.error("CKEditor is not loaded.");
      return;
    }

    const introElement = document.getElementById("editor");
    const contentElement = document.getElementById("editor1");

    // Initialize CKEditor only if elements exist
    if (introElement) {
      const introEditor = window.CKEDITOR.replace("editor", {
        allowedContent: true,
        extraPlugins: "list,font",
        toolbar: [
          { name: "document", items: ["Source"] },
          { name: "basicstyles", items: ["Bold", "Italic", "Underline"] },
          { name: "paragraph", items: ["NumberedList", "BulletedList"] },
          { name: "insert", items: ["Image", "Table", "Link", "Unlink"] },
          { name: "styles", items: ["Format", "Font", "FontSize"] },
          { name: "colors", items: ["TextColor", "BGColor"] },
        ],
      });

      if (introEditor) {
        introEditor.on("instanceReady", function () {
          introEditor.setData(data.introduction); // Avoid null values
        });

        introEditor.on("change", function () {
          setData((prev) => ({
            ...prev,
            introduction: introEditor.getData(),
          }));
        });
      } else {
        console.error("CKEditor failed to initialize for #editor.");
      }
    } else {
      console.error("Textarea with id='editor' not found.");
    }

    if (contentElement) {
      const contentEditor = window.CKEDITOR.replace("editor1", {
        extraPlugins: "list,font",
        toolbar: [
          { name: "document", items: ["Source"] },
          { name: "basicstyles", items: ["Bold", "Italic", "Underline"] },
          { name: "paragraph", items: ["NumberedList", "BulletedList"] },
          { name: "insert", items: ["Image", "Table", "Link", "Unlink"] },
          { name: "styles", items: ["Format", "Font", "FontSize"] },
          { name: "colors", items: ["TextColor", "BGColor"] },
        ],
      });

      if (contentEditor) {
        contentEditor.on("instanceReady", function () {
          contentEditor.setData(data.content || ""); // Avoid null values
        });

        contentEditor.on("change", function () {
          setData((prev) => ({
            ...prev,
            content: contentEditor.getData(),
          }));
        });
      } else {
        console.error("CKEditor failed to initialize for #editor1.");
      }
    } else {
      console.error("Textarea with id='editor1' not found.");
    }
  };

  useEffect(() => {
    if (data && blogById !== null) {
      initializeCKEditor(data, setData);
    }
  }, [data, blogById, isClient]);

  // Slug generator
  function createSlug(title) {
    return title
      .toLowerCase()
      .replace(/[^a-z0-9\s-]/g, "")
      .trim()
      .replace(/\s+/g, "-")
      .replace(/-+/g, "-");
  }


   const handleFeatureUpload = async (file) => {
   if (!file) {
      toast.error("Please select a file first.");
      return;
    }

    const formData = new FormData();
    formData.append("upload", file); // "upload" should match the backend field name
try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/user/uploadFile`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (response.data.uploaded) {
         setData((prev) => ({
        ...prev,
        featuredImage: response.data.url, // Save URL from upload response
      }));
      
        toast.success("File uploaded successfully!");
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      console.error("Upload failed:", error);
      toast.error("Error uploading file.");
    }

};
  return (
    <div>
      {error && <p>{error}</p>}
      {blogById ? (
        <div className="container mt-5">
          <button
            className="btn btn-outline-primary my-2"
            onClick={() => navigate(`/blog-management/index`)}
          >
            <i className="fa fa-list mx-1"></i>
            List Blog
          </button>
          <ToastContainer />

          <form
            onSubmit={handleFileUpload}
            className="p-3 border rounded shadow-sm mb-3 w-50"
          >
            <label htmlFor="file" className="form-label fw-bold">
              <i className="fa fa-upload me-2"></i>Image Uploader
            </label>

            <input
              type="file"
              onChange={(e) => setFile(e.target.files[0])}
              className="form-control mb-2"
            />

            <p className="text-danger small">Max size: 2MB</p>
            <p className="text-danger small">
          Note: Copy the Url after Upload and use in the Article
        </p>

            <button type="submit" className="btn btn-success w-100">
              Upload
            </button>
            {/* Show File URL & Copy Button */}
            {fileUrl && (
              <div className="mt-3">
                <p>
                  <strong>File URL:</strong>{" "}
                  <a href={fileUrl} target="_blank" rel="noopener noreferrer">
                    {fileUrl}
                  </a>
                </p>
                <button onClick={handleCopy} className="btn btn-primary">
                  Copy URL
                </button>
              </div>
            )}
          </form>

          <form
            onSubmit={onSubmitHandler}
            className="border p-4 rounded shadow-sm bg-light"
          >
            <h3 className="text-center mb-4">Edit Article</h3>

            {/* Title */}
            <div className="form-group mb-3">
              <label
                className="required-field"
                htmlFor="exampleFormControlInput1"
              >
                Title
              </label>
              <input
                type="text"
                name="title"
                required
                value={data.title}
                onChange={onChangeHandler}
                className="form-control"
                placeholder="Enter title"
              />
            </div>

            {/* URL */}
            <div className="form-group mb-3">
              <label
                className="required-field"
                htmlFor="exampleFormControlInput1"
              >
                Slug
              </label>
              <input
                type="text"
                required
                name="url"
                value={data.url}
                onChange={onChangeHandler}
                className="form-control"
                placeholder="Enter URL"
              />
            </div>

            {/* Featured Image */}
        <div className="form-group mb-3">
          <label className="required-field" htmlFor="featuredImage">
            <i className="fa fa-image me-2"></i>Featured Image
          </label>
          <input
            type="file"
            accept="image/*"
            name="featuredImage"
            onChange={(e) => {
              const file = e.target.files[0];
              if (file) {
                handleFeatureUpload(file);
              }
            }}
            className="form-control"
          />

          {data.featuredImage && (
            <img
              src={data.featuredImage}
              alt="Preview"
              className="img-fluid mt-2 rounded"
              style={{ maxHeight: "150px" }}
            />
          )}
        </div>

            {/* Introduction */}
            <div className="form-group mb-3">
              

              <label htmlFor="introduction">
                <i className="fa fa-info-circle me-2"></i><span className="required-field">Introduction</span>
                <p className="text-danger small">
              Note: Ensure the image is displayed with a strict width and height
              of 100%. <br /> Do not use H1 tag, use H2 onwards
            </p>
              </label>
              <textarea id="editor"></textarea>
            </div>

            <br />
            <br />

            {/* Content */}
            <div className="form-group mb-3">
              <label htmlFor="content">
                <i className="fa fa-align-left me-2"></i>Content
                <p className="text-danger small">
              Note: Ensure the image is displayed with a strict width and height
              of 100%. <br /> Do not use H1 tag, use H2 onwards
            </p>
              </label>
              <textarea id="editor1"></textarea>
            </div>

            {/* Meta Title & Meta Keywords */}
            <div className="form-group mb-3">
              <div className="row">
                <div className="col-md-6">
                  <label htmlFor="metaTitle">Meta Title</label>
                  <input
                    type="text"
                    name="metaTitle"
                    value={data.metaTitle}
                    onChange={onChangeHandler}
                    className="form-control"
                    placeholder="Enter meta title"
                  />
                </div>

                <div className="col-md-6">
                  <label htmlFor="metaKeywords">Meta Keywords</label>
                  <input
                    type="text"
                    name="metaKeywords"
                    value={data.metaKeywords}
                    onChange={onChangeHandler}
                    className="form-control"
                    placeholder="Enter meta keywords"
                  />
                </div>
              </div>
            </div>

            {/* Meta Description */}
            {/* Meta Description */}
        <div className="row">
        <div className="col-md-6 mb-3">
          <label htmlFor="categories">
            <i className="fa fa-tags me-2"></i>Categories
          </label>
          <Select
            isMulti
            options={categories}
            value={selectedCategories}
            onChange={setSelectedCategories}
            placeholder="Select categories"
            className="basic-multi-select"
            classNamePrefix="select"
          />
        </div>
        <div className="col-md-6 mb-3">
         <label htmlFor="metaDiscription">Meta Description</label>
              <textarea
                name="metaDiscription"
                onChange={onChangeHandler}
                value={data.metaDiscription}
                className="form-control"
                rows="4"
                placeholder="Enter meta description"
              />
        </div>
        </div>
        <br />
            

            {/* Submit Button */}
            <div className="text-center">
              <input
                type="submit"
                className="btn btn-primary px-5 py-2"
                value="Submit"
              />
            </div>
            <div className="d-flex justify-content-end">
              <button
                className="btn btn-outline-primary my-2"
                onClick={() => navigate(`/blog-management/index`)}
              >
                <i className="fa fa-list mx-1"></i>
                List Blog
              </button>
            </div>
          </form>
        </div>
      ) : (
        <p>
          <ToastContainer />
        </p>
      )}
    </div>
  );
};

export default Blogedit;
